import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import DepartmentManager from '../../base/DepartmentManager';
import { useDepartments } from '@/hooks/queries/useDepartments';

interface DepartmentsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DepartmentsModal: React.FC<DepartmentsModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('admin');
  const { data: departments = [], isLoading: isLoadingDepartments } = useDepartments();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" placement="center" backdrop="blur" scrollBehavior="inside">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          {t('users.departments.title', { defaultValue: 'Manage Departments' })}
        </ModalHeader>
        <ModalBody className="pb-6">
          <DepartmentManager departments={departments} isLoading={isLoadingDepartments} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DepartmentsModal;
